<template>
  <div
    class="tw:leading-none tw:max-w-max tw:text-sm tw:border tw:border-gray-700 tw:rounded-full tw:py-1.5 tw:px-2 tw:font-bold"
  >
    {{ $t('contact_info_badge')
    }}<span class="tw:ml-1" :class="hasCampaign ? 'tw:text-green-700' : 'tw:text-gray-500'">{{ $t(status) }}</span>
  </div>
</template>
<script setup>
defineProps({
  hasCampaign: Boolean,
  status: String,
})
</script>
